export default function discountCodeAutoscroller() {
    const discountButtons = document.querySelectorAll('.qq__autoscroll-button');
    const qqContainer = document.querySelector('.old_qq');
    if (!qqContainer || !discountButtons.length) {
        console.error('Discount code autoscroller elements not found');
        return;
    }
    const scrollToQQContainer = () => {
        qqContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    discountButtons.forEach((button) => {
        button.addEventListener('click', scrollToQQContainer);
    });
}
